module.exports = __webpack_public_path__ + "img/cb.616d6f20.jpg";